export const BareRoutes = {
  FullIntelligenceReport: "/intelligence-reports/:reportId/full",
  ReportRedirectBySn: "/reports/:deviceSN",
} as const
